import { CARD_H, CARD_W, EMBED_SIZE, IMAGENET_MEAN, IMAGENET_STD } from "./constants.js";
import { resizeArea, toU8 } from "./image.js";

/* ===========================================================================
   Stage 5.3b — the ONNX embedding channel.
   =========================================================================== */

/**
 * embed.preprocess: 488 x 680 uint8 -> normalised NCHW float, one card.
 *
 * The uint8 round after the resize mirrors cv2.resize, which hands preprocess an 8-bit
 * image before the divide by 255 — the reference vectors in embeddings.npy were all
 * produced through that quantisation.
 */
export function preprocessForModel(card) {
  const resized = toU8(resizeArea(card, CARD_W, CARD_H, EMBED_SIZE, EMBED_SIZE, 4));
  const plane = EMBED_SIZE * EMBED_SIZE;
  const out = new Float32Array(3 * plane);
  for (let i = 0; i < plane; i++) {
    for (let c = 0; c < 3; c++) {
      out[c * plane + i] = (resized[i * 4 + c] / 255 - IMAGENET_MEAN[c]) / IMAGENET_STD[c];
    }
  }
  return out;
}
